module.exports = __webpack_public_path__ + "img/IMG_3456.5bca68e5.jpg";